import { render } from "./RpcServer.vue?vue&type=template&id=28f28fea&scoped=true"
import script from "./RpcServer.vue?vue&type=script&lang=js"
export * from "./RpcServer.vue?vue&type=script&lang=js"

import "./RpcServer.vue?vue&type=style&index=0&id=28f28fea&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f28fea"]])

export default __exports__